const BASE_URL = "https://uat-pddwms.aidogcatpet.com";
// const BASE_URL = "http://uat-lsapi.aidogcatpet.com";
export default BASE_URL;
